import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../../investment_offer/constants/investment_offer_constants";
import {ViewType} from "../../view_type/ViewType";

export enum SearchListingInvestmentViewType {
    PL = "PL",
    ABROAD = "ABROAD",
    HOLIDAY = "HOLIDAY"
}

export const useSearchListingInvestmentViewType = () => {
    const viewType = useSelector((state: IRPStore) => state.viewType);
    const investmentCategories = useSelector((state: IRPStore) => state.investmentOffer.categories);
    const [searchListingInvestmentViewType, setSearchListingInvestmentViewType] = useState<SearchListingInvestmentViewType | null>(null);
    useEffect(() => {
        const isInvestmentView = viewType.current && [ViewType.FOR_INVESTMENT_LIST, ViewType.FOR_INVESTMENT_LIST_MAP].includes(viewType.current);
        const isOffersView = viewType.current && [ViewType.OFFER_LIST, ViewType.OFFER_LIST_MAP].includes(viewType.current);
        const isAbroadOffersView = viewType.current && [ViewType.OFFER_LIST_ABROAD, ViewType.OFFER_LIST_MAP_ABROAD].includes(viewType.current);
        if (isOffersView) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.PL);
            return;
        }

        if ((isInvestmentView && investmentCategories?.category === InvestmentOfferTypeSlug.ABROAD) || isAbroadOffersView) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.ABROAD);
            return;
        }

        if (isInvestmentView && investmentCategories?.category === InvestmentOfferTypeSlug.HOLIDAY) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.HOLIDAY);
            return;
        }

        setSearchListingInvestmentViewType(null);
    }, [viewType, investmentCategories?.category]);

    return searchListingInvestmentViewType;
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../../investment_offer/constants/investment_offer_constants";
import {ViewType} from "../../view_type/ViewType";

export enum SearchListingInvestmentViewType {
    PL = "PL",
    ABROAD = "ABROAD",
    HOLIDAY = "HOLIDAY"
}

export const useSearchListingInvestmentViewType = () => {
    const viewType = useSelector((state: IRPStore) => state.viewType);
    const investmentCategories = useSelector((state: IRPStore) => state.investmentOffer.categories);
    const [searchListingInvestmentViewType, setSearchListingInvestmentViewType] = useState<SearchListingInvestmentViewType | null>(null);
    useEffect(() => {
        const isInvestmentView = viewType.current && [ViewType.FOR_INVESTMENT_LIST, ViewType.FOR_INVESTMENT_LIST_MAP].includes(viewType.current);
        const isOffersView = viewType.current && [ViewType.OFFER_LIST, ViewType.OFFER_LIST_MAP].includes(viewType.current);
        const isAbroadOffersView = viewType.current && [ViewType.OFFER_LIST_ABROAD, ViewType.OFFER_LIST_MAP_ABROAD].includes(viewType.current);
        if (isOffersView) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.PL);
            return;
        }

        if ((isInvestmentView && investmentCategories?.category === InvestmentOfferTypeSlug.ABROAD) || isAbroadOffersView) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.ABROAD);
            return;
        }

        if (isInvestmentView && investmentCategories?.category === InvestmentOfferTypeSlug.HOLIDAY) {
            setSearchListingInvestmentViewType(SearchListingInvestmentViewType.HOLIDAY);
            return;
        }

        setSearchListingInvestmentViewType(null);
    }, [viewType, investmentCategories?.category]);

    return searchListingInvestmentViewType;
};
